import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../i18n/LanguageContext';
import type { Lang } from '../i18n/translations';
type Props = {
  size?: 'sm' | 'md';
};
export function LanguageToggle({
  size = 'md'
}: Props) {
  const {
    lang,
    setLang,
    t
  } = useTranslation();
  const options: {
    code: Lang;
    label: string;
  }[] = [{
    code: 'en',
    label: 'EN'
  }, {
    code: 'es',
    label: 'ES'
  }];
  const padding = size === 'sm' ? 'px-2 py-1 text-[11px]' : 'px-3 py-1.5 text-xs';
  return <div role="group" aria-label={t.nav.language} className="relative inline-flex items-center bg-white border border-lavender-100 rounded-full p-0.5 shadow-sm" data-id="element-425">
      {options.map(opt => {
      const active = opt.code === lang;
      return <button key={opt.code} type="button" aria-pressed={active} onClick={() => setLang(opt.code)} className={`relative ${padding} font-semibold tracking-wide rounded-full transition-colors ${active ? 'text-white' : 'text-gray-500 hover:text-lavender-600'}`} data-id="element-426">
            {active && <motion.span layoutId="lang-pill" className="absolute inset-0 rounded-full bg-lavender-500" transition={{
          type: 'spring',
          stiffness: 380,
          damping: 30
        }} data-id="element-427" />}
            <span className="relative z-10" data-id="element-428">{opt.label}</span>
          </button>;
    })}
    </div>;
}